import type { ReactNode } from 'react'
import type { LearnerProfileData } from '~/gql/users/learner-profile'
import ProfileGroups from './ProfileGroups'
import ProfileHeader from './ProfileHeader'
import ProfileIndicators from './ProfileIndicators'
import ProfileInfo from './ProfileInfo'

type LearnerProfileViewProps = {
  profile: LearnerProfileData
  headerActions?: ReactNode
  infoAction?: ReactNode
  /** Les blocs chargés à part (sessions, attestations, connexions). */
  children?: ReactNode
}

/**
 * La fiche apprenant (#242), rendue à partir de ses données seules : la page la
 * nourrit de l'API, la démonstration de la visite guidée de données fictives.
 */
function LearnerProfileView({ profile, headerActions, infoAction, children }: LearnerProfileViewProps) {
  return (
    <div className="flex flex-col gap-4">
      <ProfileHeader profile={profile} actions={headerActions} />
      <ProfileIndicators profile={profile} />
      <div className="grid gap-4 lg:grid-cols-2">
        <ProfileInfo profile={profile} action={infoAction} />
        <ProfileGroups groups={profile.groups} />
      </div>
      {children}
    </div>
  )
}

export default LearnerProfileView
